<script setup lang="ts">
import Outlet from '@/components/Outlet.vue'
import { provide } from 'vue'

const props = defineProps({
  aws_url: {
    type: String,
    required: true
  },
  stripe_key: {
    type: String,
    required: true
  },
  erpnext_url: {
    type: String,
    required: true
  },
  lang: {
    type: String,
    required: true
  },
  revolut_mode: {
    type: String,
    required: true,
    default: 'prod'
  }
})

provide('lang', props.lang)
</script>

<template>
  <outlet :aws_url="aws_url" :stripe_key="stripe_key" :erpnext_url="erpnext_url" :revolut_mode="revolut_mode">
    <slot></slot>
  </outlet>
</template>

<style>
@import './assets/main.css';
@import './assets/intl-input.css';
@import 'js-datepicker/dist/datepicker.min.css';
</style>
